import { render, staticRenderFns } from "./ShortcutsModal.vue?vue&type=template&id=10b55e34&scoped=true"
import script from "./ShortcutsModal.vue?vue&type=script&lang=js"
export * from "./ShortcutsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b55e34",
  null
  
)

export default component.exports